var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// src/trip/query/trip.tsx
import React13 from "react";
import { EGDSTab, EGDSTabs, EGDSTabsBackGroundColorType, EGDSTabsType } from "@egds/react-core/tabs";
import { EGDSHeading as EGDSHeading4 } from "@egds/react-core/text";
import { gql as gql14, useQuery } from "@shared-ui/apollo-client-wrapper";
import { useBexApi } from "@shared-ui/bex-api-context";

// src/trip/fragment/trip-category/trip-category.tsx
import React12 from "react";
import { EGDSButtonSize as EGDSButtonSize4, EGDSSecondaryButton as EGDSSecondaryButton4 } from "@egds/react-core/button";
import { EGDSCard as EGDSCard4, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon5 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem, MinMax } from "@egds/react-core/layout-grid";
import { EGDSScrollable } from "@egds/react-core/scrollable";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { gql as gql13 } from "@shared-ui/apollo-client-wrapper";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";

// src/trip/fragment/booking-details/trip-booking.tsx
import React10 from "react";
import { gql as gql11 } from "@shared-ui/apollo-client-wrapper";

// src/trip/fragment/booking-details/booking-detail.tsx
import React8 from "react";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
import { gql as gql9 } from "@shared-ui/apollo-client-wrapper";
import { useExperiment } from "@shared-ui/experiment-context";

// ../internal/src/components/egds-badge/egds-standard-badge.tsx
import React3 from "react";
import { EGDSBadgeStandard } from "@egds/react-core/badge";
import { gql as gql3 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-graphic/egds-graphic.tsx
import React2 from "react";
import { gql as gql2 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-graphic/egds-icon.tsx
import React from "react";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { gql } from "@shared-ui/apollo-client-wrapper";
var __EGDSIconFragment = gql`
  fragment EGDSIconFragment on Icon {
    description
    id
    size
    title
    theme
    spotLight
  }
`;
var mapSpotlight = spotlight => {
  if (!spotlight) {
    return void 0;
  }
  switch (spotlight) {
    case "STANDARD" /* STANDARD */:
      return "standard";
    case "POSITIVE" /* POSITIVE */:
      return "positive";
    case "WARNING" /* WARNING */:
      return "warning";
    case "INFO" /* INFO */:
      return "info";
    default:
      return void 0;
  }
};
var HelpCenterEGDSIcon = ({
  data,
  size
}) => {
  var _a, _b;
  const iconName = data ? data.id : "";
  const finalSize = size != null ? size : (data == null ? void 0 : data.size) && EGDSIconSize[data.size];
  const spotlight = data == null ? void 0 : data.spotLight;
  const title = (_a = data == null ? void 0 : data.title) != null ? _a : void 0;
  return /* @__PURE__ */React.createElement(EGDSIcon, {
    id: iconName,
    name: iconName,
    size: finalSize,
    title,
    theme: (_b = data == null ? void 0 : data.theme) != null ? _b : void 0,
    spotlight: mapSpotlight(spotlight)
  });
};
HelpCenterEGDSIcon.displayName = "HelpCenterEGDSIcon";
HelpCenterEGDSIcon.fragment = __EGDSIconFragment;

// ../internal/src/components/egds-graphic/egds-graphic.tsx
var __EGDSGraphicFragment = gql2`
  fragment EGDSGraphicFragment on UIGraphic {
    ... on Icon {
      ...EGDSIconFragment
    }
  }

  ${HelpCenterEGDSIcon.fragment}
`;
var EGDSGraphic = ({
  data
}) => {
  switch (data.__typename) {
    case "Icon":
      return /* @__PURE__ */React2.createElement(HelpCenterEGDSIcon, {
        data
      });
    default:
      return null;
  }
};
EGDSGraphic.displayName = "EGDSGraphic";
EGDSGraphic.fragment = __EGDSGraphicFragment;

// ../internal/src/components/egds-badge/egds-badge-themes-map.ts
var standardBadgeThemesMap = {
  standard: "standard",
  emphasis: "emphasis",
  info: "info",
  featured: "featured",
  brand: "brand",
  warning: "warning",
  positive: "positive"
};

// ../internal/src/components/egds-badge/egds-standard-badge.tsx
var EGDSStandardBadgeFragment__ = gql3`
  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {
    __typename
    text
    theme
    graphic {
      ...EGDSGraphicFragment
    }
  }
  ${EGDSGraphic.fragment}
`;
var HelpCenterEGDSBadge = ({
  data
}) => {
  var _a;
  if (!data.text) {
    return null;
  }
  return /* @__PURE__ */React3.createElement(EGDSBadgeStandard, {
    text: data.text,
    theme: standardBadgeThemesMap[(_a = data.theme) != null ? _a : "standard"]
  }, data.graphic && /* @__PURE__ */React3.createElement(EGDSGraphic, {
    data: data.graphic
  }));
};
HelpCenterEGDSBadge.displayName = "HelpCenterEGDSBadge";
HelpCenterEGDSBadge.fragment = EGDSStandardBadgeFragment__;

// src/trip/fragment/booking-action/booking-actions.tsx
import React7 from "react";
import { gql as gql8 } from "@shared-ui/apollo-client-wrapper";

// src/trip/fragment/booking-action/intent-button.tsx
import React5 from "react";
import { EGDSButtonSize, EGDSSecondaryButton as EGDSSecondaryButton2 } from "@egds/react-core/button";
import { gql as gql6 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-button/egds-button.tsx
import React4 from "react";
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
import { gql as gql4 } from "@shared-ui/apollo-client-wrapper";
var __fragment = gql4`
  fragment EGDSButtonFragment on EGDSButton {
    primary
    disabled
    icon {
      ...EGDSIconFragment
    }
    accessibility
  }
  ${HelpCenterEGDSIcon.fragment}
`;
var HelpCenterEGDSButton = _a => {
  var _b = _a,
    {
      data,
      onClickHandler,
      isDisabled,
      type,
      iconPosition = "LEADING" /* LEADING */
    } = _b,
    otherProps = __objRest(_b, ["data", "onClickHandler", "isDisabled", "type", "iconPosition"]);
  const {
    primary,
    disabled,
    accessibility,
    __typename,
    icon
  } = data;
  const buttonProps = {
    disabled: disabled || isDisabled,
    title: accessibility,
    type,
    onClick: onClickHandler
  };
  switch (__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React4.createElement(EGDSPrimaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UISecondaryButton":
      return /* @__PURE__ */React4.createElement(EGDSSecondaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    case "UITertiaryButton":
      return /* @__PURE__ */React4.createElement(EGDSTertiaryButton, __spreadValues(__spreadValues({}, buttonProps), otherProps), icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }), primary, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React4.createElement(HelpCenterEGDSIcon, {
        data: icon
      }));
    default:
      return null;
  }
};
HelpCenterEGDSButton.displayName = "HelpCenterEGDSButton";
HelpCenterEGDSButton.fragment = __fragment;

// src/trip/fragment/booking-action/intent-button.tsx
import { useVirtualAgentContext } from "@shared-ui/retail-help-center-util";

// src/trip/analytics/clickstream-analytics.ts
import { gql as gql5 } from "@shared-ui/apollo-client-wrapper";
var BookingActionsClickStreamAnalyticsFragment = gql5`
  fragment BookingActionsClickStreamAnalyticsFragment on BookingActionsClickStreamAnalytics {
    event {
      eventName
      eventType
      eventCategory
      eventVersion
      actionLocation
      actionReason
      __typename
    }
    tripDetail {
      tripDomainId
      __typename
    }
    experience {
      pageName
      appName
      appVersion
      pageNameDetailed
      __typename
    }
    workFlowList {
      intent
      orderLineId
      productLine
      subIntent
      automationStatus
      automationStatusReason
      channel
      __typename
    }
    __typename
  }
`;

// ../internal/src/utils/constants.ts
var EVENT_TYPE = "Interaction";
var EVENT_VERSION = "1.2.0";
var PAGE_NAME = "Help Articles";
var PAGE_NAME_DETAILED = "Help Articles";
var APP_NAME = "ecp-help-center";
var APP_VERSION = "1.0.0";
var HOME_PAGE = "home_page";
var HELP_CENTER_TRIP_SELECTED = "help_center_trip.selected";
var HELP_CENTER_TRIP_EVENT_CATEGORY = "help_center_trip";

// src/trip/analytics/helper.ts
var buildTrip = analytics => {
  var _a;
  if (analytics.tripDetail && analytics.tripDetail.length > 0) {
    return {
      trip: {
        trip_detail_list: [{
          trip_domain_id: (_a = analytics.tripDetail[0].tripDomainId) != null ? _a : ""
        }]
      }
    };
  }
  return {};
};
var buildWorkFlowList = analytics => {
  var _a;
  if (analytics.workFlowList && analytics.workFlowList.length > 0) {
    const firstWorkFlow = analytics.workFlowList[0];
    const workflow = __spreadValues({
      intent: firstWorkFlow.intent,
      automation_status: firstWorkFlow.automationStatus,
      automation_status_reason: firstWorkFlow.automationStatusReason,
      product_line: firstWorkFlow.productLine,
      order_line_id: (_a = firstWorkFlow.orderLineId) != null ? _a : "",
      channel: firstWorkFlow.channel
    }, firstWorkFlow.subIntent && {
      sub_intent: firstWorkFlow.subIntent
    });
    return {
      work_flow_list: {
        work_flow_list: [workflow]
      }
    };
  }
  return {};
};
var buildClickStreamForBookingActions = bookingActionsClickStreamAnalytics => {
  const trip = buildTrip(bookingActionsClickStreamAnalytics);
  const workFlowList = buildWorkFlowList(bookingActionsClickStreamAnalytics);
  return __spreadValues(__spreadValues({
    event: __spreadValues(__spreadValues({
      event_name: bookingActionsClickStreamAnalytics.event.eventName,
      event_version: bookingActionsClickStreamAnalytics.event.eventVersion,
      event_type: bookingActionsClickStreamAnalytics.event.eventType,
      event_category: bookingActionsClickStreamAnalytics.event.eventCategory
    }, bookingActionsClickStreamAnalytics.event.actionLocation && {
      action_location: bookingActionsClickStreamAnalytics.event.actionLocation
    }), bookingActionsClickStreamAnalytics.event.actionReason && {
      action_reason: bookingActionsClickStreamAnalytics.event.actionReason
    }),
    experience: {
      page_name: bookingActionsClickStreamAnalytics.experience.pageName,
      app_name: bookingActionsClickStreamAnalytics.experience.appName,
      app_version: bookingActionsClickStreamAnalytics.experience.appVersion,
      page_name_detailed: bookingActionsClickStreamAnalytics.experience.pageNameDetailed
    }
  }, workFlowList), trip);
};
var buildClickStreamAnalyticsForTripSelectedEvent = (tripName, numberOfBookings) => {
  return {
    event: {
      event_name: HELP_CENTER_TRIP_SELECTED,
      event_version: EVENT_VERSION,
      event_type: EVENT_TYPE,
      event_category: HELP_CENTER_TRIP_EVENT_CATEGORY,
      action_location: HOME_PAGE
    },
    experience: {
      page_name: PAGE_NAME,
      app_name: APP_NAME,
      app_version: APP_VERSION,
      page_name_detailed: PAGE_NAME_DETAILED
    },
    trip: {
      trip_detail_list: [{
        trip_name: tripName != null ? tripName : "",
        trip_item_count: numberOfBookings.match(/\d+/)[0] ? parseInt(numberOfBookings, 10) : 0
      }]
    }
  };
};

// src/trip/fragment/booking-action/intent-button.tsx
var fragment = gql6`
  fragment HelpCenterIntentButtonFragment on HelpCenterIntentButtons {
    name {
      ...EGDSButtonFragment
    }
    skillName
    vaText
    payload
    bookingActionsClickStreamAnalytics {
      ...BookingActionsClickStreamAnalyticsFragment
    }
    __typename
  }
  ${HelpCenterEGDSButton.fragment}
  ${BookingActionsClickStreamAnalyticsFragment}
`;
var IntentButton = ({
  data
}) => {
  const {
    controller
  } = useVirtualAgentContext();
  const trackClick = useEgClickstream();
  const bookingActions = data.bookingActionsClickStreamAnalytics;
  return /* @__PURE__ */React5.createElement(EGDSSecondaryButton2, {
    type: "button",
    size: EGDSButtonSize.SMALL,
    onClick: async () => {
      const message = {
        text: data.vaText,
        messageType: "POSTBACK",
        intent: data.skillName
      };
      if (data.payload) {
        message.payload = data.payload;
        controller.sendMessage(message);
      }
      if (bookingActions) {
        trackClick(buildClickStreamForBookingActions(bookingActions));
      }
    }
  }, data.name.primary);
};
IntentButton.fragment = fragment;
IntentButton.displayName = "IntentButtons";

// src/trip/fragment/booking-action/link-button.tsx
import React6 from "react";
import { EGDSButtonSize as EGDSButtonSize2 } from "@egds/react-core/button";
import { gql as gql7 } from "@shared-ui/apollo-client-wrapper";
var fragment2 = gql7`
  fragment HelpCenterLinkButtonFragment on HelpCenterLinkButton {
    name {
      ...EGDSButtonFragment
      action {
        ... on UILinkAction {
          resource {
            value
          }
        }
      }
    }
  }
  ${HelpCenterEGDSButton.fragment}
`;
var LinkButton = ({
  data
}) => {
  return /* @__PURE__ */React6.createElement(HelpCenterEGDSButton, {
    data: data == null ? void 0 : data.name,
    size: EGDSButtonSize2.SMALL,
    onClickHandler: () => {
      var _a, _b;
      if (((_b = (_a = data == null ? void 0 : data.name) == null ? void 0 : _a.action) == null ? void 0 : _b.__typename) === "UILinkAction") {
        window.open(data.name.action.resource.value);
      }
    },
    type: "button"
  });
};
LinkButton.fragment = fragment2;
LinkButton.displayName = "LinkButtons";

// src/trip/fragment/booking-action/booking-actions.tsx
var fragment3 = gql8`
  fragment BookingActionButtonFragment on BookingActionButton {
    ...HelpCenterLinkButtonFragment
    ...HelpCenterIntentButtonFragment
  }
  ${LinkButton.fragment}
  ${IntentButton.fragment}
`;
var BookingAction = ({
  data
}) => {
  switch (data.__typename) {
    case "HelpCenterIntentButtons":
      return /* @__PURE__ */React7.createElement(IntentButton, {
        data
      });
    case "HelpCenterLinkButton":
      return /* @__PURE__ */React7.createElement(LinkButton, {
        data
      });
    default:
      return null;
  }
};
BookingAction.fragment = fragment3;
BookingAction.displayName = "BookingActions";

// src/trip/fragment/booking-details/booking-detail.tsx
var fragment4 = gql9`
  fragment BookingDetailFragment on BookingDetail {
    icon {
      id
      __typename
    }
    timePeriod
    itineraryNumberText
    title
    product
    bookingActions {
      ...BookingActionButtonFragment
    }
    bookingBadges {
      ...EGDSStandardBadgeFragment
    }
    __typename
  }
  ${BookingAction.fragment}
  ${EGDSStandardBadgeFragment__}
`;
var BookingDetail = ({
  data
}) => {
  var _a;
  const {
    exposure
  } = useExperiment("HELP_CENTER_TRIP_VIEW_M5");
  const isHcomTripViewEnabled = useExperiment("Help_Center_Trip_View_Intelligent_Search_HCOM_Rollout").exposure.bucket === 1;
  if (exposure.bucket === 0 && !isHcomTripViewEnabled) {
    return /* @__PURE__ */React8.createElement(EGDSSpacing, {
      margin: {
        blockend: "two"
      }
    }, /* @__PURE__ */React8.createElement(EGDSCard, {
      padded: true,
      border: true
    }, /* @__PURE__ */React8.createElement(EGDSLayoutFlex, {
      space: "two",
      alignItems: "center"
    }, /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React8.createElement(EGDSIcon2, {
      name: data.icon.id
    })), /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React8.createElement("div", null, /* @__PURE__ */React8.createElement(EGDSHeading, {
      tag: "h4",
      size: 6
    }, data.title), /* @__PURE__ */React8.createElement(EGDSText, {
      size: 200
    }, data.timePeriod), /* @__PURE__ */React8.createElement(EGDSText, {
      size: 200
    }, data.itineraryNumberText)))), /* @__PURE__ */React8.createElement(EGDSSpacing, {
      margin: {
        blockstart: "two"
      }
    }, /* @__PURE__ */React8.createElement(EGDSLayoutFlex, {
      space: "three",
      alignItems: "end",
      wrap: "wrap"
    }, data.bookingActions.map((action, index1) => /* @__PURE__ */React8.createElement(EGDSCard, {
      key: index1
    }, /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React8.createElement(BookingAction, {
      data: action
    }))))))));
  }
  return /* @__PURE__ */React8.createElement(EGDSSpacing, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React8.createElement(EGDSCard, {
    padded: true,
    border: true
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlex, {
    space: "two",
    alignItems: "center"
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, null, (data == null ? void 0 : data.bookingBadges) !== null && ((_a = data == null ? void 0 : data.bookingBadges) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */React8.createElement(EGDSLayoutFlex, {
    space: "two"
  }, data == null ? void 0 : data.bookingBadges.map((el, i) => /* @__PURE__ */React8.createElement(HelpCenterEGDSBadge, {
    key: i,
    data: el
  })))))), /* @__PURE__ */React8.createElement(EGDSSpacing, {
    margin: {
      blockend: "two",
      blockstart: "two"
    }
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React8.createElement("div", null, /* @__PURE__ */React8.createElement(EGDSHeading, {
    tag: "h4",
    size: 6
  }, data.title), /* @__PURE__ */React8.createElement(EGDSText, {
    size: 200
  }, data.timePeriod), /* @__PURE__ */React8.createElement(EGDSText, {
    size: 200
  }, data.itineraryNumberText)))), /* @__PURE__ */React8.createElement(EGDSSpacing, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlex, {
    space: "three",
    alignItems: "end",
    wrap: "wrap"
  }, data.bookingActions.map((action, index1) => /* @__PURE__ */React8.createElement(EGDSCard, {
    key: index1
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React8.createElement(BookingAction, {
    data: action
  }))))))));
};
BookingDetail.fragment = fragment4;
BookingDetail.displayName = "BookingDetails";

// src/trip/fragment/booking-details/unsupported-booking.tsx
import React9 from "react";
import { EGDSButtonSize as EGDSButtonSize3, EGDSSecondaryButton as EGDSSecondaryButton3 } from "@egds/react-core/button";
import { EGDSCard as EGDSCard2 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { gql as gql10 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
var fragment5 = gql10`
  fragment UnsupportedBookingFragment on UnSupportedBooking {
    heading
    description
    clickstreamPayload {
      ...BookingActionsClickStreamAnalyticsFragment
    }
    goToTrips {
      __typename
      primary
      icon {
        id
        description
        token
        __typename
      }
      action {
        accessibility
        ... on UILinkAction {
          __typename
          resource {
            value
          }
        }

        analytics {
          linkName
          referrerId
        }
        __typename
      }
    }
    __typename
  }
  ${BookingActionsClickStreamAnalyticsFragment}
`;
var UnsupportedBooking = ({
  data
}) => {
  var _a, _b, _c, _d, _e;
  const trackClick = useEgClickstream2();
  return /* @__PURE__ */React9.createElement(EGDSCard2, {
    padded: true,
    border: true
  }, /* @__PURE__ */React9.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React9.createElement(EGDSHeading2, {
    tag: "h4",
    size: 6
  }, data == null ? void 0 : data.heading)), /* @__PURE__ */React9.createElement(EGDSText2, {
    size: 300
  }, data == null ? void 0 : data.description), /* @__PURE__ */React9.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React9.createElement(EGDSSecondaryButton3, {
    type: "button",
    tag: "a",
    href: ((_b = (_a = data == null ? void 0 : data.goToTrips) == null ? void 0 : _a.action) == null ? void 0 : _b.__typename) === "UILinkAction" ? data == null ? void 0 : data.goToTrips.action.resource.value : "",
    target: "_blank",
    size: EGDSButtonSize3.SMALL,
    onClick: () => {
      trackClick(buildClickStreamForBookingActions(data.clickstreamPayload));
    }
  }, /* @__PURE__ */React9.createElement(EGDSIcon3, {
    name: ((_d = (_c = data == null ? void 0 : data.goToTrips) == null ? void 0 : _c.icon) == null ? void 0 : _d.id) || ""
  }), (_e = data == null ? void 0 : data.goToTrips) == null ? void 0 : _e.primary)));
};
UnsupportedBooking.fragment = fragment5;
UnsupportedBooking.displayName = "UnsupportedBookings";

// src/trip/fragment/booking-details/trip-booking.tsx
var fragment6 = gql11`
  fragment TripBookingFragment on TripBooking {
    ...UnsupportedBookingFragment
    ...BookingDetailFragment
  }
  ${UnsupportedBooking.fragment}
  ${BookingDetail.fragment}
`;
var TripBooking = ({
  data
}) => {
  switch (data.__typename) {
    case "BookingDetail":
      return /* @__PURE__ */React10.createElement(BookingDetail, {
        data
      });
    case "UnSupportedBooking":
      return /* @__PURE__ */React10.createElement(UnsupportedBooking, {
        data
      });
    default:
      return null;
  }
};
TripBooking.fragment = fragment6;
TripBooking.displayName = "TripBooking";

// src/trip/fragment/trip-category/trip-info-overview.tsx
import React11 from "react";
import { EGDSBadgeStandard as EGDSBadgeStandard2 } from "@egds/react-core/badge";
import { EGDSCard as EGDSCard3, EGDSCardContentSection, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon4, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSScrim, EGDSScrimType } from "@egds/react-core/scrim";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText3 } from "@egds/react-core/text";
import { gql as gql12 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream3 } from "@shared-ui/clickstream-analytics-context";
import { defaultViewSizes, useMediaQueries, ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var fragment7 = gql12`
  fragment HelpCenterTripInfoFragment on HelpCenterTripInfo {
    backToTripButton
    header
    tripName
    image {
      description
      url
      __typename
    }
    timePeriod
    numberOfBooking
    bookingIcons {
      id
      __typename
    }
    tripBookings {
      ...TripBookingFragment
    }
    __typename
  }
  ${TripBooking.fragment}
`;
var HelpCenterTripInfo = ({
  data,
  onSelect,
  selected
}) => {
  const viewSize = useMediaQueries({
    viewSizes: defaultViewSizes
  });
  const trackClick = useEgClickstream3();
  const figureContent = trip => {
    var _a, _b, _c;
    return /* @__PURE__ */React11.createElement(React11.Fragment, null, /* @__PURE__ */React11.createElement(EGDSImage, {
      placeholderImage: true,
      alt: (_a = trip == null ? void 0 : trip.image) == null ? void 0 : _a.description,
      src: (_b = trip == null ? void 0 : trip.image) == null ? void 0 : _b.url
    }), /* @__PURE__ */React11.createElement(EGDSScrim, {
      type: EGDSScrimType.OVERLAY
    }, /* @__PURE__ */React11.createElement(EGDSCardContentSection, null, /* @__PURE__ */React11.createElement(EGDSLayoutFlex2, {
      direction: "column",
      justifyContent: "space-between",
      space: "one"
    }, /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React11.createElement(EGDSHeading3, {
      tag: "h4",
      size: 4
    }, trip.tripName)), /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React11.createElement(EGDSText3, null, trip.timePeriod)), /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React11.createElement(EGDSText3, null, trip.numberOfBooking)), /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, null, (trip == null ? void 0 : trip.bookingIcons) !== null && ((_c = trip == null ? void 0 : trip.bookingIcons) == null ? void 0 : _c.length) > 0 && /* @__PURE__ */React11.createElement(EGDSLayoutFlex2, {
      space: "two"
    }, trip == null ? void 0 : trip.bookingIcons.map((el, i) => /* @__PURE__ */React11.createElement(EGDSBadgeStandard2, {
      key: i,
      theme: "standard"
    }, /* @__PURE__ */React11.createElement(EGDSIcon4, {
      name: el.id,
      size: EGDSIconSize2.SMALL
    })))))))));
  };
  return /* @__PURE__ */React11.createElement(EGDSSpacing3, {
    margin: {
      blockend: "three",
      inlineend: "two"
    }
  }, /* @__PURE__ */React11.createElement(EGDSCard3, {
    selected: viewSize !== defaultViewSizes.SMALL && selected,
    "data-stid": "trip-info-overview"
  }, /* @__PURE__ */React11.createElement(Viewport, null, /* @__PURE__ */React11.createElement(ViewSmall, null, /* @__PURE__ */React11.createElement(EGDSFigure, {
    ratio: EGDSFigureAspectRatioType.R21_9
  }, figureContent(data))), /* @__PURE__ */React11.createElement(ViewLarge, null, /* @__PURE__ */React11.createElement(EGDSFigure, {
    ratio: EGDSFigureAspectRatioType.R4_1
  }, figureContent(data)))), /* @__PURE__ */React11.createElement(EGDSCardLink, null, /* @__PURE__ */React11.createElement("button", {
    onClick: () => {
      onSelect == null ? void 0 : onSelect();
      trackClick(buildClickStreamAnalyticsForTripSelectedEvent(data.tripName, data.numberOfBooking));
    },
    type: "button"
  }, data.tripName))));
};
HelpCenterTripInfo.fragment = fragment7;
HelpCenterTripInfo.displayName = "TripInfoOverview";

// src/trip/fragment/trip-category/trip-category.tsx
var fragment8 = gql13`
  fragment TripCategoryFragment on TripCategory {
    header
    tabTitle
    tripInfos {
      ...HelpCenterTripInfoFragment
    }
  }
  ${HelpCenterTripInfo.fragment}
`;
var TripCategory = ({
  data,
  selected
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const [tripInfoData, setTripInfoData] = React12.useState(null);
  const [selectedTile, setSelectedTile] = React12.useState(0);
  React12.useEffect(() => {
    setTripInfoData(null);
    setSelectedTile(0);
  }, [selected]);
  return /* @__PURE__ */React12.createElement(EGDSCard4, null, /* @__PURE__ */React12.createElement(Viewport2, null, /* @__PURE__ */React12.createElement(ViewSmall2, null, /* @__PURE__ */React12.createElement(EGDSCardContentSection2, {
    padded: false
  }, /* @__PURE__ */React12.createElement(EGDSLayoutGrid, {
    autoRows: (data == null ? void 0 : data.tripInfos) && ((_a = data == null ? void 0 : data.tripInfos) == null ? void 0 : _a.length) > 2 ? [MinMax("48x", "96x")] : ["min-content"]
  }, /* @__PURE__ */React12.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React12.createElement(EGDSScrollable, {
    direction: "vertical"
  }, !tripInfoData ? /* @__PURE__ */React12.createElement("div", null, (_b = data == null ? void 0 : data.tripInfos) == null ? void 0 : _b.map((ele, index) => {
    return /* @__PURE__ */React12.createElement(HelpCenterTripInfo, {
      data: ele,
      onSelect: () => {
        setTripInfoData(ele);
        setSelectedTile(index);
      },
      key: index,
      selected: selectedTile === index
    });
  })) : /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement(EGDSSpacing4, {
    margin: {
      blockend: "six"
    }
  }, /* @__PURE__ */React12.createElement(EGDSSecondaryButton4, {
    size: EGDSButtonSize4.LARGE,
    onClick: () => setTripInfoData ? setTripInfoData(null) : null
  }, /* @__PURE__ */React12.createElement(EGDSIcon5, {
    name: "arrow_back_iOS"
  }), tripInfoData.backToTripButton)), /* @__PURE__ */React12.createElement(EGDSCard4, null, (_c = tripInfoData == null ? void 0 : tripInfoData.tripBookings) == null ? void 0 : _c.map((booking, index) => {
    return /* @__PURE__ */React12.createElement(EGDSSpacing4, {
      margin: {
        blockstart: "two"
      },
      key: index
    }, /* @__PURE__ */React12.createElement(TripBooking, {
      data: booking
    }));
  })))))))), /* @__PURE__ */React12.createElement(ViewMedium2, null, /* @__PURE__ */React12.createElement(EGDSLayoutFlex3, {
    space: "two",
    dataTestId: "largeContent"
  }, /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem3, {
    grow: 1
  }, /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement("div", {
    "data-stid": "trip-info-overview-container"
  }, /* @__PURE__ */React12.createElement(EGDSLayoutGrid, {
    autoRows: (data == null ? void 0 : data.tripInfos) && ((_d = data == null ? void 0 : data.tripInfos) == null ? void 0 : _d.length) > 1 ? [MinMax("30x", "70x")] : ["min-content"]
  }, /* @__PURE__ */React12.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React12.createElement(EGDSScrollable, {
    direction: "vertical"
  }, (_e = data == null ? void 0 : data.tripInfos) == null ? void 0 : _e.map((ele, index) => {
    return /* @__PURE__ */React12.createElement(HelpCenterTripInfo, {
      data: ele,
      onSelect: () => {
        setTripInfoData(ele);
        setSelectedTile(index);
      },
      key: index,
      selected: selectedTile === index
    });
  }))))))), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem3, {
    minWidth: "half_width",
    maxWidth: "half_width"
  }, /* @__PURE__ */React12.createElement(EGDSLayoutGrid, {
    autoRows: [MinMax("30x", "70x")]
  }, /* @__PURE__ */React12.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React12.createElement(EGDSScrollable, {
    direction: "vertical"
  }, tripInfoData ? /* @__PURE__ */React12.createElement(EGDSCard4, null, (_f = tripInfoData == null ? void 0 : tripInfoData.tripBookings) == null ? void 0 : _f.map((booking, index) => {
    return /* @__PURE__ */React12.createElement(TripBooking, {
      data: booking,
      key: index
    });
  })) : /* @__PURE__ */React12.createElement(EGDSCard4, null, (_i = (_h = (_g = data == null ? void 0 : data.tripInfos) == null ? void 0 : _g[0]) == null ? void 0 : _h.tripBookings) == null ? void 0 : _i.map((booking, index) => {
    return /* @__PURE__ */React12.createElement(EGDSSpacing4, {
      margin: {
        blockend: "two"
      },
      key: index
    }, /* @__PURE__ */React12.createElement(TripBooking, {
      data: booking
    }));
  }))))))))));
};
TripCategory.fragment = fragment8;
TripCategory.displayName = "TripCategory";

// src/trip/query/trip.tsx
var __Query = gql14`
  query HelpCenterTripQuery($context: ContextInput!) {
    helpCenterPersonalization(context: $context) {
      helpCenterTripView {
        trip {
          header
          allTrips {
            ...TripCategoryFragment
          }
        }
      }
    }
  }
  ${TripCategory.fragment}
`;
var Trip = ({
  ssr = false
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const {
    context
  } = useBexApi();
  const [selectedTabIndex, setSelectedTabIndex] = React13.useState(0);
  const handleTabSelect = e => {
    setSelectedTabIndex(e);
  };
  const variables = {
    context
  };
  const {
    data,
    error,
    loading
  } = useQuery(__Query, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr
  });
  if (loading || error || !data) {
    return null;
  }
  return /* @__PURE__ */React13.createElement(React13.Fragment, null, ((_b = (_a = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _a.helpCenterTripView) == null ? void 0 : _b.trip) && /* @__PURE__ */React13.createElement("div", null, /* @__PURE__ */React13.createElement(EGDSHeading4, {
    tag: "h3",
    align: "left",
    size: 7
  }, (_e = (_d = (_c = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _c.helpCenterTripView) == null ? void 0 : _d.trip) == null ? void 0 : _e.header), /* @__PURE__ */React13.createElement(EGDSTabs, {
    selectedTab: selectedTabIndex,
    onTabSelect: handleTabSelect,
    tabsType: EGDSTabsType.NATURAL,
    backgroundColor: EGDSTabsBackGroundColorType.PRIMARY
  }, (_i = (_h = (_g = (_f = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _f.helpCenterTripView) == null ? void 0 : _g.trip) == null ? void 0 : _h.allTrips) == null ? void 0 : _i.map((ele, index) => {
    return /* @__PURE__ */React13.createElement(EGDSTab, {
      name: ele == null ? void 0 : ele.tabTitle,
      key: ele == null ? void 0 : ele.tabTitle
    }, /* @__PURE__ */React13.createElement(TripCategory, {
      data: ele,
      selected: selectedTabIndex === index
    }));
  }))));
};
Trip.displayName = "sharedui-Trip";

// src/bookings/query/trip-bookings.tsx
import React19 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSSheetContent } from "@egds/react-core/sheet";
import { gql as gql18, useQuery as useQuery2 } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";

// src/trip/fragment/booking-details/go-to-trips.tsx
import React14 from "react";
import { EGDSButtonSize as EGDSButtonSize5 } from "@egds/react-core/button";
import { gql as gql15 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream4 } from "@shared-ui/clickstream-analytics-context";
var fragment9 = gql15`
  fragment GoToTripsFragment on UITertiaryButton {
    __typename
    primary
    icon {
      id
      description
      token
      __typename
    }
    action {
      accessibility
      ... on UILinkAction {
        __typename
        resource {
          value
        }
      }
      analytics {
        linkName
        referrerId
      }
      __typename
    }
  }
`;
var GoToTripsButton = ({
  data,
  clickstreamPayload
}) => {
  const trackClick = useEgClickstream4();
  const handleClick = () => {
    var _a;
    if (clickstreamPayload) {
      trackClick(buildClickStreamForBookingActions(clickstreamPayload));
    }
    if (((_a = data == null ? void 0 : data.action) == null ? void 0 : _a.__typename) === "UILinkAction" && data.action.resource.value) {
      window.open(data.action.resource.value, "_blank");
    }
  };
  return /* @__PURE__ */React14.createElement(HelpCenterEGDSButton, {
    "aria-label": "go-to-trips",
    "data-testid": "go-to-trips",
    data,
    onClickHandler: handleClick,
    type: "button",
    size: EGDSButtonSize5.SMALL
  });
};
GoToTripsButton.fragment = fragment9;
GoToTripsButton.displayName = "GoToTripsButton";

// src/bookings/fragment/state/bookings-loading-state.tsx
import React15 from "react";
import { EGDSCard as EGDSCard5 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex4 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
var BookingsLoadingState = () => {
  return /* @__PURE__ */React15.createElement("div", {
    "data-testid": "loading-state-card"
  }, /* @__PURE__ */React15.createElement(EGDSCard5, {
    padded: true,
    border: true
  }, /* @__PURE__ */React15.createElement(EGDSLayoutGrid2, {
    autoColumns: ["minmax(var(--uitk-layoutgrid-egds-size__0x), 1fr)"],
    columns: ["1fr", "4fr"],
    space: "three",
    justifyContent: "start",
    alignItems: "start"
  }, /* @__PURE__ */React15.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React15.createElement(EGDSSpacing5, {
    margin: {
      blockend: "sixteen"
    }
  }, /* @__PURE__ */React15.createElement(EGDSFigure2, {
    ratio: EGDSFigureAspectRatioType2.R3_4,
    roundcorner: true
  }, /* @__PURE__ */React15.createElement(EGDSSkeleton, {
    type: "block"
  })))), /* @__PURE__ */React15.createElement(EGDSLayoutGridItem2, null, /* @__PURE__ */React15.createElement(EGDSLayoutFlex4, {
    direction: "column",
    space: "two"
  }, /* @__PURE__ */React15.createElement(EGDSSkeleton, {
    type: "line",
    lineLength: "secondary",
    lineHeight: "type-300"
  }), /* @__PURE__ */React15.createElement(EGDSSkeleton, {
    type: "line",
    lineLength: "primary",
    lineHeight: "heading-6"
  }))))));
};
BookingsLoadingState.displayName = "LoadingState-BookingCards";

// src/bookings/fragment/trip-booking-details/trip-booking-cards.tsx
import React18 from "react";
import { EGDSCard as EGDSCard6 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure3, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType3, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading5, EGDSText as EGDSText4 } from "@egds/react-core/text";
import { gql as gql17 } from "@shared-ui/apollo-client-wrapper";

// src/bookings/fragment/booking-action-cards/booking-actions.tsx
import React16 from "react";
import { EGDSButtonSize as EGDSButtonSize6 } from "@egds/react-core/button";
import { gql as gql16 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream5 } from "@shared-ui/clickstream-analytics-context";
import { useVirtualAgentContext as useVirtualAgentContext2 } from "@shared-ui/retail-help-center-util";
var fragment10 = gql16`
  fragment BookingActionFragment on HelpCenterIntentButtons {
    name {
      ...EGDSButtonFragment
    }
    skillName
    vaText
    payload
    bookingActionsClickStreamAnalytics {
      ...BookingActionsClickStreamAnalyticsFragment
    }
    __typename
  }
  ${HelpCenterEGDSButton.fragment}
  ${BookingActionsClickStreamAnalyticsFragment}
`;
var BookingAction2 = ({
  data,
  closeSideSheet
}) => {
  const {
    controller
  } = useVirtualAgentContext2();
  const trackClick = useEgClickstream5();
  const bookingActions = data.bookingActionsClickStreamAnalytics;
  return /* @__PURE__ */React16.createElement(HelpCenterEGDSButton, {
    data: __spreadProps(__spreadValues({}, data.name), {
      __typename: "UISecondaryButton"
    }),
    type: "button",
    size: EGDSButtonSize6.SMALL,
    onClickHandler: async () => {
      const message = {
        text: data.vaText,
        messageType: "POSTBACK",
        intent: data.skillName
      };
      if (data.payload) {
        message.payload = data.payload;
        controller.sendMessage(message);
      }
      if (bookingActions) {
        trackClick(buildClickStreamForBookingActions(bookingActions));
      }
      closeSideSheet();
    }
  });
};
BookingAction2.fragment = fragment10;
BookingAction2.displayName = "IntentButtons";

// src/bookings/fragment/booking-action-cards/booking-action-menu.tsx
import React17 from "react";
import { EGDSButtonSize as EGDSButtonSize7 } from "@egds/react-core/button";
import { EGDSMenu, EGDSMenuContainer, EGDSMenuList, EGDSMenuTrigger, PositionType } from "@egds/react-core/menu";
import { useEgClickstream as useEgClickstream6 } from "@shared-ui/clickstream-analytics-context";
import { useVirtualAgentContext as useVirtualAgentContext3 } from "@shared-ui/retail-help-center-util";
var BookingActionMenu = ({
  data,
  closeSideSheet
}) => {
  const {
    controller
  } = useVirtualAgentContext3();
  const trackClick = useEgClickstream6();
  const [isMenuOpen, setIsMenuOpen] = React17.useState(false);
  const handleMenuClick = () => setIsMenuOpen(!isMenuOpen);
  const menuItems = data.bookingActions ? data.bookingActions.slice(2).map((item, i) => {
    return {
      attributes: {
        role: "menuitem",
        tabindex: i
      },
      className: "uitk-list-item",
      label: item.name.primary,
      typeAnchor: true,
      onClick: async () => {
        const message = {
          text: item.vaText,
          messageType: "POSTBACK",
          intent: item.skillName
        };
        if (item.payload) {
          message.payload = item.payload;
          controller.sendMessage(message);
        }
        if (item.bookingActionsClickStreamAnalytics) {
          trackClick(buildClickStreamForBookingActions(item.bookingActionsClickStreamAnalytics));
        }
        closeSideSheet();
      }
    };
  }) : [];
  return /* @__PURE__ */React17.createElement(EGDSMenu, {
    isOpen: isMenuOpen,
    onTriggerClick: handleMenuClick
  }, data.bookingActions && data.bookingActions.length > 2 && /* @__PURE__ */React17.createElement(EGDSMenuTrigger, null, /* @__PURE__ */React17.createElement(HelpCenterEGDSButton, {
    type: "button",
    size: EGDSButtonSize7.SMALL,
    data: {
      primary: data.viewMoreOptionsText,
      accessibility: null,
      __typename: "UITertiaryButton",
      icon: null,
      disabled: false
    }
  })), /* @__PURE__ */React17.createElement(EGDSMenuContainer, {
    position: PositionType.LEFT
  }, /* @__PURE__ */React17.createElement(EGDSMenuList, {
    items: menuItems
  })));
};
BookingActionMenu.displayName = "BookingActionMenu";

// src/bookings/fragment/trip-booking-details/trip-booking-cards.tsx
var fragment11 = gql17`
  fragment TripBookingsFragment on BookingDetail {
    viewMoreOptionsText
    timePeriod
    itineraryNumberText
    title
    image {
      url
      description
    }
    product
    bookingActions {
      ...BookingActionFragment
    }
    bookingBadges {
      ...EGDSStandardBadgeFragment
    }
    __typename
  }
  ${BookingAction2.fragment}
  ${HelpCenterEGDSBadge.fragment}
`;
var TripBookingCards = ({
  data,
  closeSideSheet
}) => {
  var _a;
  return /* @__PURE__ */React18.createElement(EGDSCard6, {
    padded: true,
    border: true,
    overflow: true
  }, /* @__PURE__ */React18.createElement(EGDSLayoutGrid3, {
    autoColumns: ["minmax(var(--uitk-layoutgrid-egds-size__0x), 1fr)"],
    columns: ["1fr", "4fr"],
    space: "three"
  }, /* @__PURE__ */React18.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */React18.createElement(EGDSFigure3, {
    ratio: EGDSFigureAspectRatioType3.R3_4,
    roundcorner: true
  }, /* @__PURE__ */React18.createElement(EGDSImage2, {
    alt: data.image ? data.image.description : "alternative text",
    placeholderImage: true,
    src: data.image ? data.image.url : "true"
  }))), /* @__PURE__ */React18.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */React18.createElement(EGDSLayoutFlex5, {
    direction: "column",
    space: "small"
  }, /* @__PURE__ */React18.createElement(EGDSLayoutFlex5, {
    space: "two"
  }, (_a = data == null ? void 0 : data.bookingBadges) == null ? void 0 : _a.map((el, i) => /* @__PURE__ */React18.createElement(HelpCenterEGDSBadge, {
    key: i,
    data: el
  }))), /* @__PURE__ */React18.createElement(EGDSLayoutFlex5, {
    direction: "column",
    space: "one"
  }, data.product === "Activity" || data.product === "Car" ? /* @__PURE__ */React18.createElement(React18.Fragment, null, /* @__PURE__ */React18.createElement(EGDSHeading5, {
    tag: "h3",
    size: 6
  }, data.title.split("::")[0]), /* @__PURE__ */React18.createElement(EGDSHeading5, {
    tag: "h3",
    size: 6
  }, data.title.split("::")[1])) : /* @__PURE__ */React18.createElement(EGDSHeading5, {
    tag: "h3",
    size: 6
  }, data.title), /* @__PURE__ */React18.createElement(EGDSText4, {
    size: 300
  }, data.timePeriod), /* @__PURE__ */React18.createElement(EGDSText4, {
    size: 300
  }, data.itineraryNumberText))))), /* @__PURE__ */React18.createElement(EGDSSpacing6, {
    margin: {
      blockstart: "three",
      blockend: "two"
    }
  }, /* @__PURE__ */React18.createElement(EGDSLayoutFlex5, {
    direction: "column",
    space: "medium"
  }, (data.bookingActions.length === 3 ? data.bookingActions : data.bookingActions.slice(0, 2)).map((action, index1) => /* @__PURE__ */React18.createElement(EGDSCard6, {
    key: index1
  }, /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem4, null, action.__typename === "HelpCenterIntentButtons" && /* @__PURE__ */React18.createElement(BookingAction2, {
    data: action,
    closeSideSheet
  })))))), data.bookingActions && data.bookingActions.length > 3 && /* @__PURE__ */React18.createElement(EGDSLayoutFlex5, {
    justifyContent: "center"
  }, /* @__PURE__ */React18.createElement(BookingActionMenu, {
    data,
    closeSideSheet
  })));
};
TripBookingCards.fragment = fragment11;
TripBookingCards.displayName = "BookingCards";

// src/bookings/query/trip-bookings.tsx
var __Query2 = gql18`
  query HelpCenterTripBookingQuery($context: ContextInput!, $tripId: String!) {
    helpCenterPersonalization(context: $context, tripId: $tripId) {
      helpCenterBookingView {
        timePeriod
        header
        tripBookings {
          ...TripBookingsFragment
        }
        goToTrips {
          ...GoToTripsFragment
        }
      }
    }
  }
  ${TripBookingCards.fragment}
  ${GoToTripsButton.fragment}
`;
var TripBookings = ({
  ssr = false,
  bookingPayload = {
    timePeriod: "",
    tripId: "",
    tripName: ""
  },
  closeSideSheet
}) => {
  const {
    tripId,
    tripName,
    timePeriod
  } = bookingPayload;
  const {
    context
  } = useBexApi2();
  const variables = {
    context,
    tripId: tripId != null ? tripId : ""
  };
  const {
    data,
    error,
    loading
  } = useQuery2(__Query2, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr
  });
  const renderContent = isLoading => {
    var _a, _b, _c, _d, _e;
    const commonContent = /* @__PURE__ */React19.createElement(EGDSSheetContent, null, /* @__PURE__ */React19.createElement(EGDSLayoutFlex6, {
      direction: "column",
      space: "six"
    }, isLoading ? [...Array(2)].map((_, index) => /* @__PURE__ */React19.createElement(BookingsLoadingState, {
      key: index
    })) : (_c = (_b = (_a = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _a.helpCenterBookingView) == null ? void 0 : _b.tripBookings) == null ? void 0 : _c.map((booking, index) => /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem5, {
      key: index
    }, booking.__typename === "BookingDetail" && /* @__PURE__ */React19.createElement(TripBookingCards, {
      data: booking,
      closeSideSheet
    }))), /* @__PURE__ */React19.createElement(EGDSLayoutFlex6, null, /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem5, null, ((_e = (_d = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _d.helpCenterBookingView) == null ? void 0 : _e.goToTrips) && /* @__PURE__ */React19.createElement(GoToTripsButton, {
      "data-testid": "go-to-trips",
      data: data.helpCenterPersonalization.helpCenterBookingView.goToTrips
    })))));
    return commonContent;
  };
  if (loading) {
    return renderContent(true);
  }
  if (error || !data) {
    return null;
  }
  return renderContent(false);
};
TripBookings.displayName = "sharedui-Tripbookings";

// src/trip/query/tripmtwo.tsx
import React26, { useState } from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSSheet, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { EGDSTab as EGDSTab2, EGDSTabs as EGDSTabs2, EGDSTabsBackGroundColorType as EGDSTabsBackGroundColorType2, EGDSTabsType as EGDSTabsType2 } from "@egds/react-core/tabs";
import { EGDSHeading as EGDSHeading8, EGDSText as EGDSText7 } from "@egds/react-core/text";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { gql as gql24, useQuery as useQuery3 } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";

// src/trip/fragment/state/empty-state.tsx
import React22 from "react";
import { EGDSIllustrations } from "@egds/react-core/illustrations";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSParagraph, EGDSText as EGDSText5 } from "@egds/react-core/text";
import { gql as gql21 } from "@shared-ui/apollo-client-wrapper";

// src/trip/fragment/state/existing-booking-button.tsx
import React20 from "react";
import { EGDSButtonSize as EGDSButtonSize8 } from "@egds/react-core/button";
import { gql as gql19 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream7 } from "@shared-ui/clickstream-analytics-context";
import { useVirtualAgentContext as useVirtualAgentContext4 } from "@shared-ui/retail-help-center-util";
var fragment12 = gql19`
  fragment ExistingBookingButtonFragment on HelpCenterIntentButtons {
    name {
      ...EGDSButtonFragment
      __typename
    }
    skillName
    vaText
    payload
    bookingActionsClickStreamAnalytics {
      ...BookingActionsClickStreamAnalyticsFragment
    }
    __typename
  }
  ${HelpCenterEGDSButton.fragment}
  ${BookingActionsClickStreamAnalyticsFragment}
`;
var ExistingBookingButton = _a => {
  var _b = _a,
    {
      data
    } = _b,
    props = __objRest(_b, ["data"]);
  const {
    controller
  } = useVirtualAgentContext4();
  const trackClick = useEgClickstream7();
  const bookingActions = data.bookingActionsClickStreamAnalytics;
  const handleClick = async () => {
    const message = {
      text: data.vaText,
      messageType: "POSTBACK",
      intent: data.skillName
    };
    if (data.payload) {
      message.payload = data.payload;
      controller.sendMessage(message);
    }
    if (bookingActions) {
      trackClick(buildClickStreamForBookingActions(bookingActions));
    }
  };
  return /* @__PURE__ */React20.createElement(HelpCenterEGDSButton, __spreadProps(__spreadValues({
    type: "button"
  }, props), {
    data: data.name,
    size: EGDSButtonSize8.MEDIUM,
    onClickHandler: handleClick
  }));
};
ExistingBookingButton.fragment = fragment12;
ExistingBookingButton.displayName = "ExistingBookingButton";

// src/trip/fragment/state/start-shopping-button.tsx
import React21 from "react";
import { EGDSButtonSize as EGDSButtonSize9 } from "@egds/react-core/button";
import { gql as gql20 } from "@shared-ui/apollo-client-wrapper";
var fragment13 = gql20`
  fragment StartShoppingButtonFragment on UITertiaryButton {
    primary
    disabled
    accessibility
    icon {
      ...EGDSIconFragment
    }
    __typename
    action {
      ... on UILinkAction {
        __typename
        resource {
          value
        }
      }
    }
  }
  ${HelpCenterEGDSButton.fragment}
`;
var StartShoppingButton = _a => {
  var _b = _a,
    {
      data
    } = _b,
    props = __objRest(_b, ["data"]);
  const handleClick = () => {
    var _a2;
    const action = data == null ? void 0 : data.action;
    if ((action == null ? void 0 : action.__typename) === "UILinkAction" && ((_a2 = action.resource) == null ? void 0 : _a2.value)) {
      window.location.href = action.resource.value;
    }
  };
  return /* @__PURE__ */React21.createElement(HelpCenterEGDSButton, __spreadProps(__spreadValues({
    data: __spreadProps(__spreadValues({}, data), {
      __typename: data.__typename
    }),
    size: EGDSButtonSize9.MEDIUM,
    onClickHandler: handleClick,
    type: "button"
  }, props), {
    "data-stid": "start-shopping-button"
  }));
};
StartShoppingButton.fragment = fragment13;
StartShoppingButton.displayName = "StartShoppingButton";

// src/trip/fragment/state/empty-state.tsx
var fragment14 = gql21`
  fragment EmptyStateFragment on EmptyState {
    illustration {
      url
      description
      egdsElementId
      id
    }
    text
    existingBooking {
      ...ExistingBookingButtonFragment
    }
    startShopping {
      ...StartShoppingButtonFragment
    }
  }
  ${ExistingBookingButton.fragment}
  ${StartShoppingButton.fragment}
  ${IntentButton.fragment}
`;
var EmptyState = ({
  data
}) => {
  var _a, _b;
  return /* @__PURE__ */React22.createElement(EGDSLayoutFlex7, {
    justifyContent: "center",
    alignItems: "center",
    direction: "column",
    blockSize: "full_size",
    "data-testid": "empty-state"
  }, /* @__PURE__ */React22.createElement(EGDSLayoutFlex7, {
    direction: "column",
    alignItems: "center",
    space: "four"
  }, /* @__PURE__ */React22.createElement(EGDSSpacing7, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React22.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React22.createElement(EGDSIllustrations, {
    alt: ((_a = data == null ? void 0 : data.illustration) == null ? void 0 : _a.description) || "",
    url: (_b = data == null ? void 0 : data.illustration) == null ? void 0 : _b.url
  }))), /* @__PURE__ */React22.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React22.createElement(EGDSParagraph, null, /* @__PURE__ */React22.createElement(EGDSText5, {
    align: "center"
  }, data == null ? void 0 : data.text))), /* @__PURE__ */React22.createElement(EGDSLayoutFlexItem6, null, (data == null ? void 0 : data.existingBooking) && /* @__PURE__ */React22.createElement(ExistingBookingButton, {
    data: data.existingBooking,
    "data-testid": "intent-button-primary"
  })), /* @__PURE__ */React22.createElement(EGDSLayoutFlexItem6, null, (data == null ? void 0 : data.startShopping) && /* @__PURE__ */React22.createElement(StartShoppingButton, {
    data: data == null ? void 0 : data.startShopping,
    "data-testid": "start-shopping-button"
  })), /* @__PURE__ */React22.createElement(EGDSSpacing7, {
    padding: {
      blockend: "four"
    }
  })));
};
EmptyState.fragment = fragment14;
EmptyState.displayName = "EmptyState";

// src/trip/fragment/state/loading-state.tsx
import React23 from "react";
import { EGDSCard as EGDSCard7, EGDSCardContentSection as EGDSCardContentSection3 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { EGDSSkeleton as EGDSSkeleton2 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
var LoadingState = () => {
  const skeletonCards = Array.from({
    length: 3
  });
  return /* @__PURE__ */React23.createElement(EGDSSpacing8, {
    padding: {
      blockstart: "three",
      blockend: "three"
    }
  }, /* @__PURE__ */React23.createElement("div", {
    "data-testid": "loading-state-grid"
  }, /* @__PURE__ */React23.createElement(EGDSLayoutGrid4, {
    columns: ["repeat(auto-fit, 327px)"],
    space: "medium",
    justifyContent: "center"
  }, skeletonCards.map((_, index) => /* @__PURE__ */React23.createElement(EGDSLayoutGridItem4, {
    key: `loading-${index}`
  }, /* @__PURE__ */React23.createElement("div", {
    "data-testid": `loading-card-${index}`
  }, /* @__PURE__ */React23.createElement(EGDSCard7, {
    style: {
      minHeight: "152px"
    }
  }, /* @__PURE__ */React23.createElement(EGDSCardContentSection3, {
    padded: false
  }, /* @__PURE__ */React23.createElement(EGDSLayoutGridItem4, null, /* @__PURE__ */React23.createElement("div", {
    "data-testid": `loading-skeleton-${index}`
  }, /* @__PURE__ */React23.createElement(EGDSSkeleton2, {
    cornerRadius: 1,
    type: "block",
    color: "007BFF"
  })))))))))));
};
var loading_state_default = LoadingState;

// src/trip/fragment/trip-category/trip-category-pill.tsx
import React25 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid5, EGDSLayoutGridItem as EGDSLayoutGridItem5, MinMax as MinMax2 } from "@egds/react-core/layout-grid";
import { EGDSScrollable as EGDSScrollable2 } from "@egds/react-core/scrollable";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7 } from "@egds/react-core/text";
import { gql as gql23 } from "@shared-ui/apollo-client-wrapper";

// src/trip/fragment/trip-category/trip-info-card.tsx
import React24 from "react";
import { EGDSBadgeStandard as EGDSBadgeStandard3 } from "@egds/react-core/badge";
import { EGDSCard as EGDSCard8, EGDSCardContentSection as EGDSCardContentSection4, EGDSCardLink as EGDSCardLink2 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon6, EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
import { EGDSFigure as EGDSFigure4, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType4, EGDSImage as EGDSImage3 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSScrim as EGDSScrim2, EGDSScrimType as EGDSScrimType2 } from "@egds/react-core/scrim";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading6, EGDSText as EGDSText6 } from "@egds/react-core/text";
import { gql as gql22 } from "@shared-ui/apollo-client-wrapper";
import { useEgClickstream as useEgClickstream8 } from "@shared-ui/clickstream-analytics-context";
var fragment15 = gql22`
  fragment HelpCenterTripInfoWithYearFragment on HelpCenterTripInfo {
    backToTripButton
    header
    tripId
    tripName
    image {
      description
      url
      __typename
    }
    timePeriod
    yearOfTrip
    numberOfBooking
    bookingIcons {
      id
      __typename
    }
    tripBookings {
      ...TripBookingFragment
    }
    __typename
  }
  ${TripBooking.fragment}
`;
var HelpCenterTripInfoCard = ({
  data,
  onSelect,
  selected,
  openSheet
}) => {
  const trackClick = useEgClickstream8();
  const handleCardClick = () => {
    onSelect == null ? void 0 : onSelect();
    trackClick(buildClickStreamAnalyticsForTripSelectedEvent(data.tripName, data.numberOfBooking));
  };
  const figureContent = trip => {
    var _a, _b, _c;
    return /* @__PURE__ */React24.createElement(React24.Fragment, null, /* @__PURE__ */React24.createElement(EGDSImage3, {
      placeholderImage: true,
      alt: (_a = trip == null ? void 0 : trip.image) == null ? void 0 : _a.description,
      src: (_b = trip == null ? void 0 : trip.image) == null ? void 0 : _b.url
    }), /* @__PURE__ */React24.createElement(EGDSScrim2, {
      type: EGDSScrimType2.OVERLAY
    }, /* @__PURE__ */React24.createElement(EGDSCardContentSection4, null, /* @__PURE__ */React24.createElement(EGDSSpacing9, {
      padding: {
        blockstart: "six",
        inlineend: "two",
        blockend: "one",
        inlinestart: "two"
      }
    }, /* @__PURE__ */React24.createElement(EGDSLayoutFlex8, {
      direction: "column",
      justifyContent: "space-between",
      space: "one"
    }, /* @__PURE__ */React24.createElement(EGDSLayoutFlexItem7, null, (trip == null ? void 0 : trip.bookingIcons) !== null && ((_c = trip == null ? void 0 : trip.bookingIcons) == null ? void 0 : _c.length) > 0 && /* @__PURE__ */React24.createElement(EGDSLayoutFlex8, {
      space: "two"
    }, trip == null ? void 0 : trip.bookingIcons.map((el, i) => /* @__PURE__ */React24.createElement(EGDSBadgeStandard3, {
      key: i,
      theme: "standard",
      className: "egds-badge"
    }, /* @__PURE__ */React24.createElement(EGDSIcon6, {
      name: el.id,
      size: EGDSIconSize3.SMALL,
      "data-icon-name": el.id,
      className: "egds-icon"
    }))))), /* @__PURE__ */React24.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React24.createElement(EGDSHeading6, {
      tag: "h3",
      size: 4,
      overflow: "truncate"
    }, trip.tripName)), /* @__PURE__ */React24.createElement(EGDSLayoutFlexItem7, null, /* @__PURE__ */React24.createElement(EGDSText6, {
      className: "egds-text"
    }, trip.timePeriod)))))));
  };
  return /* @__PURE__ */React24.createElement(EGDSSpacing9, null, /* @__PURE__ */React24.createElement(EGDSCard8, {
    "data-stid": "trip-info-card-overview",
    className: selected ? "egds-card--selected" : void 0,
    onClick: handleCardClick
  }, /* @__PURE__ */React24.createElement("div", {
    "data-ratio": "21:9",
    className: "egds-figure"
  }, /* @__PURE__ */React24.createElement(EGDSFigure4, {
    ratio: EGDSFigureAspectRatioType4.R21_9
  }, figureContent(data))), /* @__PURE__ */React24.createElement(EGDSCardLink2, null, /* @__PURE__ */React24.createElement("button", {
    "data-stid": "trip-bookings-button",
    onClick: () => {
      openSheet(data.tripId, data.tripName, data.timePeriod);
      onSelect == null ? void 0 : onSelect();
      trackClick(buildClickStreamAnalyticsForTripSelectedEvent(data.tripName, data.numberOfBooking));
    },
    type: "button"
  }, data.tripName))));
};
HelpCenterTripInfoCard.fragment = fragment15;
HelpCenterTripInfoCard.displayName = "TripInfoCard";

// src/trip/fragment/trip-category/trip-category-pill.tsx
var fragment16 = gql23`
  fragment TripCategoryPillFragment on TripCategory {
    header
    tabTitle
    tripInfos {
      ...HelpCenterTripInfoWithYearFragment
      timePeriod
      yearOfTrip
    }
  }
  ${HelpCenterTripInfoCard.fragment}
`;
var TripCategoryPill = ({
  data,
  selected,
  openSheet
}) => {
  var _a, _b;
  const groupedTrips = React25.useMemo(() => {
    if (!(data == null ? void 0 : data.tripInfos) || (data == null ? void 0 : data.tabTitle.toLowerCase()) !== "past" && (data == null ? void 0 : data.tabTitle.toLowerCase()) !== "canceled") {
      return null;
    }
    const groups = data.tripInfos.reduce((acc, trip) => {
      if (!(trip == null ? void 0 : trip.yearOfTrip)) {
        return acc;
      }
      const year = trip.yearOfTrip;
      if (!acc[year]) {
        acc[year] = [];
      }
      acc[year] = [...acc[year], trip];
      return acc;
    }, {});
    return groups;
  }, [data == null ? void 0 : data.tripInfos, data == null ? void 0 : data.tabTitle]);
  return /* @__PURE__ */React25.createElement(EGDSLayoutGrid5, {
    autoRows: (data == null ? void 0 : data.tripInfos) && ((_a = data == null ? void 0 : data.tripInfos) == null ? void 0 : _a.length) > 1 ? [MinMax2("24x", "48x")] : ["min-content"],
    "data-stid": "trip-category-grid"
  }, /* @__PURE__ */React25.createElement(EGDSLayoutGridItem5, null, /* @__PURE__ */React25.createElement(EGDSScrollable2, {
    direction: "vertical",
    "data-stid": "trip-scrollable-container"
  }, /* @__PURE__ */React25.createElement(EGDSSpacing10, {
    padding: {
      inlineend: "three"
    }
  }, groupedTrips ? /* @__PURE__ */React25.createElement("div", {
    "data-stid": "all-trips-container"
  }, Object.entries(groupedTrips).sort(([yearA], [yearB]) => Number(yearB) - Number(yearA)).map(([year, trips]) => {
    if (!(trips == null ? void 0 : trips.length)) {
      return null;
    }
    return /* @__PURE__ */React25.createElement(EGDSSpacing10, {
      key: year,
      padding: {
        blockend: "four"
      }
    }, /* @__PURE__ */React25.createElement(EGDSLayoutFlex9, {
      direction: "column",
      space: "three"
    }, /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React25.createElement(EGDSHeading7, {
      tag: "h2",
      size: 6,
      "data-stid": "trip-year-heading"
    }, year)), /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React25.createElement(EGDSLayoutGrid5, {
      columns: ["repeat(auto-fit, 327px)"],
      space: "small",
      "data-stid": `trip-grid-${year}`
    }, trips.map((trip, index) => trip ? /* @__PURE__ */React25.createElement(EGDSLayoutGridItem5, {
      key: `${year}-${index}`
    }, /* @__PURE__ */React25.createElement(HelpCenterTripInfoCard, {
      data: trip,
      openSheet,
      "data-stid": `trip-info-${year}-${index}`
    })) : null)))));
  })) :
  // Non-past trips regular grid
  /* @__PURE__ */
  React25.createElement("div", {
    "data-stid": "non-past-trips-section"
  }, /* @__PURE__ */React25.createElement(EGDSLayoutGrid5, {
    columns: ["repeat(auto-fit, 327px)"],
    space: "small",
    "data-stid": "trip-info-grid"
  }, (_b = data == null ? void 0 : data.tripInfos) == null ? void 0 : _b.map((ele, index) => /* @__PURE__ */React25.createElement("div", {
    "data-stid": "trip-info-overview",
    key: index
  }, /* @__PURE__ */React25.createElement(EGDSLayoutGridItem5, null, /* @__PURE__ */React25.createElement(HelpCenterTripInfoCard, {
    data: ele,
    openSheet
  }))))))))));
};
TripCategoryPill.fragment = fragment16;
TripCategoryPill.displayName = "TripCategoryPill";

// src/trip/query/tripmtwo.tsx
var __Query3 = gql24`
  query HelpCenterTripQueryM2($context: ContextInput!) {
    helpCenterPersonalization(context: $context) {
      helpCenterTripView {
        trip {
          header
          emptyState {
            ...EmptyStateFragment
          }
          allTrips {
            ...TripCategoryPillFragment
          }
          goToTrips {
            ...GoToTripsFragment
          }
        }
      }
    }
  }
  ${TripCategoryPill.fragment}
  ${EmptyState.fragment}
  ${GoToTripsButton.fragment}
`;
var Tripmtwo = ({
  ssr = false
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E;
  const {
    context
  } = useBexApi3();
  const [selectedTabIndex, setSelectedTabIndex] = React26.useState(0);
  const [visible, setVisible] = React26.useState(false);
  const [bookingPayload, setBookingPayload] = useState({
    timePeriod: "",
    tripName: "",
    tripId: ""
  });
  const ref = React26.createRef();
  const handleTabSelect = React26.useCallback(index => {
    setSelectedTabIndex(index);
  }, []);
  const handleCardClick = (tripId, tripName, timePeriod) => {
    setBookingPayload({
      timePeriod,
      tripName,
      tripId
    });
    setVisible(true);
  };
  const onNavigationClick = () => {
    setVisible(!visible);
  };
  const getTripBookingView = () => {
    return /* @__PURE__ */React26.createElement(TripBookings, {
      bookingPayload,
      closeSideSheet: onNavigationClick
    });
  };
  const variables = {
    context
  };
  const {
    data,
    error,
    loading
  } = useQuery3(__Query3, {
    context: {
      shouldLogPerformance: true
    },
    variables,
    ssr
  });
  const isM2LandingPageEnabled = useExperiment2("Help_Center_Web_Landing_Page_UX_M2").exposure.bucket === 1;
  const renderSheet = isSmallView => {
    const commonContent = /* @__PURE__ */React26.createElement(EGDSSheetTransition, {
      isVisible: visible
    }, /* @__PURE__ */React26.createElement(EGDSSheet, {
      isVisible: visible,
      type: "side",
      triggerRef: ref,
      onDismiss: onNavigationClick,
      ariaLabel: bookingPayload.tripName
    }, /* @__PURE__ */React26.createElement(EGDSToolbar, {
      "data-testid": "close-sidesheet",
      navigationContent: {
        onClick: onNavigationClick,
        navIconLabel: isSmallView ? "Go back" : "Close Toolbar",
        navType: isSmallView ? "back" : void 0
      },
      toolbarTitle: isSmallView ? void 0 : bookingPayload.tripName,
      toolbarSubtitle: isSmallView ? void 0 : bookingPayload.timePeriod
    }), isSmallView && /* @__PURE__ */React26.createElement(EGDSSpacing11, {
      margin: {
        inlinestart: "six",
        inlineend: "six"
      }
    }, /* @__PURE__ */React26.createElement(EGDSLayoutFlex10, {
      direction: "column",
      space: "one"
    }, /* @__PURE__ */React26.createElement(EGDSHeading8, {
      tag: "h4",
      size: 4
    }, bookingPayload.tripName), /* @__PURE__ */React26.createElement(EGDSText7, {
      size: 300
    }, bookingPayload.timePeriod))), getTripBookingView()));
    return commonContent;
  };
  if (error) {
    return null;
  }
  if (!((_c = (_b = (_a = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _a.helpCenterTripView) == null ? void 0 : _b.trip) == null ? void 0 : _c.allTrips)) {
    return /* @__PURE__ */React26.createElement("div", {
      style: {
        marginBottom: isM2LandingPageEnabled ? "32px" : "0"
      }
    }, /* @__PURE__ */React26.createElement(Viewport3, null, /* @__PURE__ */React26.createElement(ViewSmall3, null, /* @__PURE__ */React26.createElement(EGDSHeading8, {
      "data-testid": "manage-heading",
      tag: isM2LandingPageEnabled ? "h5" : "h2",
      align: "left",
      size: isM2LandingPageEnabled ? 5 : 4
    }, (_f = (_e = (_d = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _d.helpCenterTripView) == null ? void 0 : _e.trip) == null ? void 0 : _f.header)), /* @__PURE__ */React26.createElement(ViewMedium3, null, /* @__PURE__ */React26.createElement(EGDSHeading8, {
      "data-testid": "manage-heading",
      tag: isM2LandingPageEnabled ? "h4" : "h2",
      align: "left",
      size: 4
    }, (_i = (_h = (_g = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _g.helpCenterTripView) == null ? void 0 : _h.trip) == null ? void 0 : _i.header))), ((_l = (_k = (_j = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _j.helpCenterTripView) == null ? void 0 : _k.trip) == null ? void 0 : _l.emptyState) && /* @__PURE__ */React26.createElement(EmptyState, {
      data: data.helpCenterPersonalization.helpCenterTripView.trip.emptyState
    }));
  }
  if (loading) {
    return /* @__PURE__ */React26.createElement(loading_state_default, null);
  }
  return /* @__PURE__ */React26.createElement(React26.Fragment, null, ((_n = (_m = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _m.helpCenterTripView) == null ? void 0 : _n.trip) && /* @__PURE__ */React26.createElement(EGDSLayoutFlex10, {
    alignContent: "end",
    alignItems: "stretch",
    direction: "column",
    justifyContent: "start",
    space: "three"
  }, /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem9, null, /* @__PURE__ */React26.createElement(Viewport3, null, /* @__PURE__ */React26.createElement(ViewSmall3, null, /* @__PURE__ */React26.createElement(EGDSHeading8, {
    "data-testid": "manage-heading",
    tag: isM2LandingPageEnabled ? "h5" : "h2",
    align: "left",
    size: isM2LandingPageEnabled ? 5 : 4
  }, (_q = (_p = (_o = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _o.helpCenterTripView) == null ? void 0 : _p.trip) == null ? void 0 : _q.header)), /* @__PURE__ */React26.createElement(ViewMedium3, null, /* @__PURE__ */React26.createElement(EGDSHeading8, {
    "data-testid": "manage-heading",
    tag: isM2LandingPageEnabled ? "h4" : "h2",
    align: "left",
    size: 4
  }, (_t = (_s = (_r = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _r.helpCenterTripView) == null ? void 0 : _s.trip) == null ? void 0 : _t.header)))), /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem9, null, /* @__PURE__ */React26.createElement(EGDSTabs2, {
    "data-stid": "egds-tab-container",
    selectedTab: selectedTabIndex,
    onTabSelect: handleTabSelect,
    tabsType: EGDSTabsType2.NATURAL,
    backgroundColor: EGDSTabsBackGroundColorType2.PRIMARY
  }, (_x = (_w = (_v = (_u = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _u.helpCenterTripView) == null ? void 0 : _v.trip) == null ? void 0 : _w.allTrips) == null ? void 0 : _x.map((ele, index) => {
    var _a2;
    return /* @__PURE__ */React26.createElement(EGDSTab2, {
      name: ele == null ? void 0 : ele.tabTitle,
      id: ele == null ? void 0 : ele.tabTitle,
      key: ele == null ? void 0 : ele.tabTitle,
      selected: selectedTabIndex === index,
      "aria-controls": `panel-${(_a2 = ele == null ? void 0 : ele.tabTitle) == null ? void 0 : _a2.toLowerCase()}`,
      "aria-selected": selectedTabIndex === index,
      role: "tab",
      onChange: (/* istanbul ignore next -- @preserve */
      () => handleTabSelect(index))
    });
  }))), /* @__PURE__ */React26.createElement(EGDSLayoutFlexItem9, null, (_B = (_A = (_z = (_y = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _y.helpCenterTripView) == null ? void 0 : _z.trip) == null ? void 0 : _A.allTrips) == null ? void 0 : _B.map((cardcontent, tabSelected) => {
    var _a2, _b2;
    return selectedTabIndex === tabSelected && /* @__PURE__ */React26.createElement("div", {
      key: `panel-${cardcontent == null ? void 0 : cardcontent.tabTitle}`,
      role: "tabpanel",
      id: `panel-${(_a2 = cardcontent == null ? void 0 : cardcontent.tabTitle) == null ? void 0 : _a2.toLowerCase()}`,
      "aria-labelledby": `tab-${(_b2 = cardcontent == null ? void 0 : cardcontent.tabTitle) == null ? void 0 : _b2.toLowerCase()}`,
      tabIndex: 0
    }, /* @__PURE__ */React26.createElement(TripCategoryPill, {
      key: `${cardcontent.tabTitle}-${selectedTabIndex}`,
      data: cardcontent,
      selected: true,
      openSheet: handleCardClick
    }));
  })), ((_E = (_D = (_C = data == null ? void 0 : data.helpCenterPersonalization) == null ? void 0 : _C.helpCenterTripView) == null ? void 0 : _D.trip) == null ? void 0 : _E.goToTrips) && /* @__PURE__ */React26.createElement(EGDSLayoutFlex10, {
    justifyContent: "start"
  }, /* @__PURE__ */React26.createElement(EGDSSpacing11, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React26.createElement(GoToTripsButton, {
    "data-testid": "go-to-trips",
    data: data.helpCenterPersonalization.helpCenterTripView.trip.goToTrips
  })))), /* @__PURE__ */React26.createElement(Viewport3, null, /* @__PURE__ */React26.createElement(ViewSmall3, null, renderSheet(true)), /* @__PURE__ */React26.createElement(ViewMedium3, null, renderSheet(false))));
};
Tripmtwo.displayName = "sharedui-Trip";
export { Trip, TripBookings, Tripmtwo };
/* istanbul ignore file -- @preserve */
/* istanbul ignore next -- @preserve*/
/* istanbul ignore next -- @preserve */
//# sourceMappingURL=index.js.map